<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo() {
    return {
      title: "Dhaka International University",
      meta: [
        {
          name: 'description',
          content: 'Dhaka International University is one of the leading Private University of Bangladesh. Established In 7th April 1995 by Renowned Humanist Prof.'
        },
        {property: 'og:author', content: "Dhaka International University"},
        {
          property: 'og:keywords',
          content: "DIU, Dhaka International University, Dhaka, Dhaka International, University, Private Universities In Bangladesh, Universities In Bangladesh"
        },
        {property: 'og:title', content: "Dhaka International University"},
        {property: 'og:site_name', content: 'DIU Employee Profile'},
        {property: 'og:type', content: 'website'},
        {property: 'og:url', content: 'https://profile.diu.ac/'},
        // {property: 'og:image', content: 'https://diu.ac/wp-content/themes/diu-theme-lite-v1/images/diu-logo-white.png'},
        {name: 'robots', content: 'index,follow'}
      ]
    }
  }
}
</script>

<style src="../static/css/all.css"></style>
<style src="../static/css/style.css"></style>



// WEBPACK FOOTER //
// src/App.vue